module.exports = __webpack_public_path__ + "img/warning.6c3363df.svg";